var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.133,
    height: 27.133,
    viewBox: "0 0 27.133 27.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#161616;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.64,24.707a2.713,2.713,0,1,0,2.713,2.713A2.71,2.71,0,0,0,9.64,24.707ZM1.5,3V5.713H4.213L9.1,16.01,7.266,19.334a2.623,2.623,0,0,0-.339,1.3A2.721,2.721,0,0,0,9.64,23.35H25.92V20.637H10.21a.336.336,0,0,1-.339-.339l.041-.163,1.221-2.211H21.24a2.7,2.7,0,0,0,2.374-1.4l4.857-8.8a1.325,1.325,0,0,0,.163-.651,1.361,1.361,0,0,0-1.357-1.357H7.212L5.936,3ZM23.207,24.707A2.713,2.713,0,1,0,25.92,27.42,2.71,2.71,0,0,0,23.207,24.707Z",
    transform: "translate(-1.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.d3390908cff1a2c84a8fd5b4a8d592d3.svg";
export { ForwardRef as ReactComponent };